module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-09.970e4f9c.png";